<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <!-- Adicione campos de filtro iniciais aqui -->
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="startDate"
                        :value="dataInicial"
                        :endDate="dataFinal"
                        title="data-inicio"
                        @input="changeStartDate"
                        :showClean="false"
                        :invalid="dataInicial == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <verified-date-picker
                        dateType="endDate"
                        :value="dataFinal"
                        :startDate="dataInicial"
                        title="data-fim"
                        @input="changeEndDate"
                        :showClean="false"
                        :invalid="dataFinal == null"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="cliente"
                        :value="clienteSelected"
                        :options="clienteList"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        label="rsocial"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="lps"
                        :value="lpsSelected"
                        :options="lpsList"
                        :loading="lpsLoading"
                        @search="carregarLps"
                        @input="updateLps"
                        label="nome"
                        :closeOnSelect="false"
                        multiple
                        clearable
                        searchable
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="contrato"
                        :value="contratoSelected"
                        :options="contratoSelect"
                        :loading="contratoLoading"
                        @search="carregarContratos"
                        @input="updateContrato"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="formulario"
                        :value="formularioSelected"
                        :options="formularioSelect"
                        :loading="formularioLoading"
                        @search="carregarFormularios"
                        @input="updateFormulario"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    >
                        <template #multiple-selected="{ selected }">
                            ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                        </template>
                    </vss-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RelatorioFormularioRespostaListFiltro',
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dataInicial: new Date(this.$moment().subtract(30, 'days')),
            dataFinal: new Date(),

            clienteList: [],
            clienteSelected: [],
            clienteLoading: false,

            lpsList: [],
            lpsSelected: [],
            lpsLoading: false,

            contratoSelect: [],
            contratoSelected: [],
            contratoLoading: false,
            
            formularioSelect: [],
            formularioSelected: [],
            formularioLoading: false,

        };
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
    },
    methods: {
        changeStartDate(date) {
            if (date.getTime() != this.dataInicial.getTime()) {
                this.dataInicial = date;
                if (!this.isNull(this.dataInicial)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataInicial',
                        valor: this.dataInicial,
                    });
                }
            }
        },
        changeEndDate(date) {
            if (date.getTime() != this.dataFinal.getTime()) {
                this.dataFinal = date;
                if (!this.isNull(this.dataFinal)) {
                    this.$emit('update-filtro', {
                        nomeFiltro: 'dataFinal',
                        valor: this.dataFinal,
                    });
                }
            }
        },
        clearFilter() {
            this.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.dataFinal = new Date();
            this.clienteSelected = [];
            this.lpsSelected = [];
            this.contratoSelected = [];
            this.formularioSelected = [];
        },
        carregarClientes(query = '') {
            this.clienteLoading = true;

            query = this.isNull(query) ? '' : this.removeToSearch(query);

            this.$axios
                .get(`/promotor/cliente/getcombo.json`, {
                    params: {
                        param: query,
                    },
                })
                .then((response) => {
                    this.clienteList = response.data.content.map((c) => {
                        return {
                            id: c.idcliente,
                            rsocial: c.rsocial,
                        };
                    });
                })
                .catch(() => {
                    this.clienteList = [];
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(cliente) {
            this.clienteSelected = cliente;
            this.$emit('update-filtro', {
                nomeFiltro: 'idClienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((c) => c.id),
            });
        },
        carregarLps(query = '') {
            this.lpsLoading = true;

            query = this.isNull(query) ? '' : this.removeToSearch(query);

            this.$axios
                .get(`/promotor/getcombo/lps.json`, {
                    params: {
                        param: query,
                    },
                })
                .then((response) => {
                    this.lpsList = response.data.content.map((l) => {
                        return {
                            id: l.idlps,
                            nome: l.nome,
                        };
                    });
                })
                .catch(() => {
                    this.lpsList = [];
                })
                .finally(() => {
                    this.lpsLoading = false;
                });
        },
        updateLps(lps) {
            this.lpsSelected = lps;
            this.$emit('update-filtro', {
                nomeFiltro: 'idLpsList',
                valor: this.lpsSelected.length == 0 ? [] : this.lpsSelected.map((l) => l.id),
            });
        },

        carregarContratos(query = '', byCliente = false) {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.contratoLoading = true;
            if (byCliente) this.contratoSelect = [];

            this.$axios
                .get(`/promotor/contrato/getcombo.json`, {
                    params: {
                        situacao: 2,
                        param: query,
                    },
                })
                .then((response) => {
                    this.contratoSelect = response.data.content.map((e) => ({
                        id: e.idcontrato,
                        label: e.descricao,
                    }));
                })
                .catch((e) => {
                    this.contratoSelect = [];
                })
                .finally(() => {
                    this.contratoLoading = false;
                });
        },
        updateContrato(contratoSelected) {
            this.contratoSelected = contratoSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idContratoList',
                valor:
                    this.contratoSelected.length == 0 ? [] : this.contratoSelected.map((e) => e.id),
            });
        },

        carregarFormularios(query = '') {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.formularioLoading = true;

            this.$axios
                .get(`/pro/getcombo/formFormulario.json`, {
                    params: {
                        situacao: 2,
                        param: query,
                        contexto: 'pro',
                        situacao: 2,
                    },
                })
                .then((response) => {
                    this.formularioSelect = response.data.content.map((e) => ({
                        id: e.id,
                        uuid: e.uuid,
                        label: e.titulo + ' (id: ' + e.id + ')',
                    }));
                })
                .catch((e) => {
                    this.formularioSelect = [];
                })
                .finally(() => {
                    this.formularioLoading = false;
                });
        },
        updateFormulario(formularioSelected) {
            this.formularioSelected = formularioSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idFormularioList',
                valor:
                    this.formularioSelected.length == 0 ? [] : this.formularioSelected.map((e) => e.id),
            });
        },
    },
};
</script>
